import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { Permissao } from '../models/enums/permissao';
import { ErrorService } from '../services/error.service';

import { AuthService } from './auth.service';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private errorService: ErrorService,
    private router: Router,
  ) { }

  public canActivate(next: ActivatedRouteSnapshot): Observable<boolean> {
    const permissao = next.data['permissao'] as Permissao;
    return this.authService.isLoggedIn.pipe(
      take(1),
      map((isLoggedIn: boolean) => {
        if (!isLoggedIn) {
          this.router.navigate(['/login']);
          return false;
        }
        return this.checkPermission(permissao);
      })
    );
  }

  private checkPermission(permissao: Permissao): boolean {
    const isAuthorized = this.authService.isAuthorized(permissao);
    if (!isAuthorized) { this.errorService.goToPermissionError(); }
    return isAuthorized;
  }
}
